<template>
  <b-card
          v-if="hasProtocol"
          class="w-100 mx-1 my-2 text-center"
          border-variant="dark"
          header-text-variant="white"
          header-tag="header"
          header-bg-variant="dark"
  >
    <template v-slot:header>
      <span style="font-size: 14px; font-weight: bold;">Protocol - {{ session.protocolTypeName }}</span>
      <!--
      <b-button
          style="position: absolute; top:0px; right:-6px;"
          class="text-right mx-2 px-1 py-0" aria-label="Close" variant="dark" size="sm">
        <font-awesome-icon icon="times-circle"/>
      </b-button>
      -->
    </template>

    <div class="w-100 mx-1 my-2" role="tablist">

      <b-card no-body class="mb-1" v-for="(item, index) in protocolItems" :key="index">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle="'accordion-' + index" variant="light" class="text-left">
            <div class="d-flex justify-content-between align-items-center">
              <span>{{item.name}}</span>
              <b-badge variant="dark" pill>Steps: {{item.steps.length}}</b-badge>
            </div>
            <div style="font-size: small;">
              <span>{{item.startTime | numeralFormat('00:00:00')}} <font-awesome-icon icon="arrow-right" /> </span>
              <span v-if="item.endTime"> {{item.endTime | numeralFormat('00:00:00')}}</span>
              <span> <font-awesome-icon icon="stopwatch" style="margin-right: 4px; margin-left: 12px;" />: {{item.duration | numeralFormat('00:00:00')}}</span>
            </div>
          </b-button>
        </b-card-header>

        <b-collapse :id="'accordion-' + index" accordion="my-accordion" role="tabpanel" no-body>
          <b-card-body class="text-left" style="font-size: small;">
            <b-card-text v-for="(step, sindex) in item.steps" :key="sindex">
              <b-row no-gutters>
                <b-col md="1">
                  {{step.stepNumber}}
                </b-col>
                <b-col md="10">
                  <div>
                    <span>{{step.time | numeralFormat('00:00:00')}} <font-awesome-icon icon="arrow-right" /> </span>
                    <span v-if="step.endTime"> {{item.endTime | numeralFormat('00:00:00')}}</span>
                    <span><font-awesome-icon icon="stopwatch" style="margin-right: 4px; margin-left: 8px;" />{{step.duration | numeralFormat('00:00:00')}}</span>
                    <span><strong>  Value: </strong> {{step.value}}</span>
                  </div>
                </b-col>
              </b-row>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

    </div>
  </b-card>
</template>

<script>
import {mapGetters} from "vuex";
import phaseTypes from "../../lib/PhaseTypes";

export default {
  name: "MeasurementProtocolSummary",
  props: [ 'session', 'measurementData'],
  computed: {
    ...mapGetters({
    }),

    hasProtocol: function() {
      if(!this.session || !this.session.protocolPlan) {
        return false;
      }

      let protocolData = this.measurementData.protocolData;
      return protocolData && protocolData.phases && protocolData.phases.length > 0;
    },

    protocolItems: function() {

      let items = [];

      if(this.hasProtocol) {
        let protocolData = this.measurementData.protocolData;
        for(let phase of protocolData.phases) {
          let phaseType = phaseTypes.find(phase.phaseType);
          items.push({
            name: phaseType.label,
            startTime: phase.startTime,
            duration: phase.duration,
            endTime: phase.startTime + phase.duration,
            steps: phase.steps
          })
        }
      }

      return items;
    },

  }
}
</script>

<style scoped>

</style>